<template src='./sidemenu.html'></template>

<script>
import { API_URL } from '@/main'
import axios from 'axios'
import router from '@/router/index.js'

export default {
  name: 'SideMenu',
  data() {
    return {
      menuvoices: [], // List of menu items
      currentItem: null, // Currently selected menu item
    }
  },
  mounted() {
    this.loadMenuVoices()
  },
  methods: {
    
    async loadMenuVoices() {

      const url = API_URL + 'menuvoices/MenuVoices/'
      const axiosInstance = axios.create({
        headers: {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        },
      })

      try {

        const response = await axiosInstance.get(url)
        this.menuvoices = response.data.map(voice => ({
          id: voice.id,
          menuvoice: voice.menuvoice,
          method: voice.method,
          icon: voice.icon,
        }))
      } 
      catch (error) {
      
        console.debug('Failed to load menu voices:', error)
      }
    },
    selectItem(method) {

      if(!method) {
        
        console.debug('Method is undefined for the selected menu item')
        return
      }

      console.debug("method", method)

      if (method === 'logout') {
      
        this.handleLogout()
      } 
      else {
      
        const path = `/application/${method}`
        this.$router.push({ path }).catch(err => {
          
          if(err.name !== 'NavigationDuplicated') {

            console.debug('Navigation error:', err)
          }
        })
      }
    },
    handleLogout() {
    
      localStorage.removeItem('User_id')
      localStorage.removeItem('Token')
  
      this.$router.push({ name: 'login' }).catch(err => {

        if (err.name !== 'NavigationDuplicated') {
        
          console.debug('Navigation error:', err)
        }
      })
    },    
  }
}
</script>


<style scoped>


</style>